import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-strava",
  "use": "icon-strava-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-strava\"><path d=\"M8.808.833L3.388 11.31h3.194l2.226-4.178 2.214 4.178h3.169L8.808.833zm5.383 10.477l-1.572 3.135-1.597-3.135H8.598l4.021 7.857 3.994-7.857H14.19z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol